import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type HydraGetOrderInvoiceProps = {
  hydraToken: string
  orderHref: string
}

export type HydraGetOrderInvoiceResponse = {
  invoiceHTML: Blob
}

export const HydraGetOrderInvoice = ({
  hydraToken,
  orderHref,
}: HydraGetOrderInvoiceProps) => {
  const request: SendRequestType = {
    method: 'GET',
    url: `/orders/${orderHref}/invoice.pdf?engine=enhanced`,
    token: hydraToken,
    returnType: 'blob',
  }

  return httpTools.sendRequest<Blob>(request)
}
